import { OMPLIR_TITOL_APARTAT } from "./actionTypes";

export const setTitolApartat = titol => {
  return {
    type: OMPLIR_TITOL_APARTAT,
    payload: titol
  };
};
